import { render, staticRenderFns } from "./imgbox.vue?vue&type=template&id=fc787158&scoped=true"
import script from "./imgbox.vue?vue&type=script&lang=js"
export * from "./imgbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc787158",
  null
  
)

export default component.exports